import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import { router } from '../main.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user: {},
        user_id: null,
        username: null,
        terms: [],
        sectionIdsString: '',
        sections: [],
        transcripts: [],
        credits: [],
        grades: [],
        calendars: [],
        course_rosters: [],
        billing_data: [],
        days_of_week: '',
        nav_items: [],
        userType: 0,
        instructor_names: [],
        // Check against this array to give instructor navigation
        instructor_ids: [],
        all_instructor_ids: [1561704, 1921177, 1900101, 1900105, 1900107, 1900106, 1900112, 1900108, 1900111, 1900109, 1900113, 1900110, 1900114, 1900115, 1900119, 1363452, 1900117, 1900116, 1900120, 1900121, 1900122, 1823396, 1900125, 1900123, 1900128, 1900126, 1900127, 1900129, 1900133, 1900131, 1900132, 1900130, 1900134, 1900139, 1900138, 1900135, 1900136, 1900137, 1900037, 1900038, 1900141, 1900143, 1900140, 1900142, 1900146, 1900144, 1900145, 1900152, 1900102, 1900147, 1900149, 1900151, 1900150, 1900148, 815451, 1900156, 1900155, 1900154, 1900157, 1900159, 1900160, 1900158, 1900161, 1900163, 1900164, 1900166, 1900162, 1900165, 1900168, 1900169, 1900167, 1709484, 1900175, 1900177, 1900179, 1562571, 1900176, 1900178, 1900173, 1900170, 1900180, 1900172, 1900184, 1900185, 1900186, 1900182, 1900181, 1900183, 1900187, 1900193, 1900191, 1900189, 1900188, 1900192, 1900194, 1900195, 1900197, 1900196, 1900199, 1900198, 1900103, 1900104, 1900201, 1900203, 1900204, 1900205, 1900206, 1900207, 1900208, 1900209, 1900210, 1900211, 1900212, 1900213, 1900214, 1904397, 1921153, 1921154, 1921155, 1921156, 1921157, 1921158, 1921159, 1921160, 1921161, 1921162, 1921163, 1921164, 1921165, 1921166, 1921167, 1921168, 1921169, 1921170, 1921171, 1921172, 1921173, 1921174, 1921175, 1921176, 1921177, 1921178, 1921179, 1921180, 1921181, 1921182, 1921183, 1921184, 1921185, 1921186, 1921187, 1921188, 1921189, 1921190, 1921191, 1921192, 1921193, 1921194, 1921195],
        former_students_now_instructors: [815451, 1363452, 1562571, 1709484, 1823396, 1602767],
        grades_submitted: false
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token) {
            state.status = 'success'
            state.token = token
            
        },
        gauth_request(state) {
            state.status = 'loading'
        },

        gauth_success(state, token) {
            state.status = 'success'
            state.token = token
        },

        gauth_logout_request(state) {
            state.status = 'logging_out'
            state.token = null
        },

        gauth_logout_success(state) {
            state.status = 'logged_out'
        },

        fetch_request(state) {
            state.status = 'fetching_data'
        },
        fetch_success(state, [sectionIds, credits, grades]) {
            state.status = 'fetch_success'
            state.sectionIdsString = sectionIds
            // state.terms = terms,
            state.credits = credits,
            state.grades = grades
            state.userType = 1
            // state.nav_items = [
            //     {
            //         title: "Courses",
            //         icon: "mdi-pencil",
            //         route: "/courses"
            //     },
            //     {
            //         title: "Registration",
            //         icon: "mdi-playlist-check",
            //         route: "/registration"
            //     },
            //     {
            //         title: "Transcript",
            //         icon: "mdi-clipboard-text",
            //         route: "/transcript"
            //     }
            // ]

        },

        fetch_instructors_request(state) {
            state.status = 'fetching_instructors'
        },

        fetch_instructors_success(state, instructors) {
            state.status = 'fetch_instructors_success'
            state.instructor_ids = instructors
        },

        fetch_transcript_success(state, transcripts) {
            state.status = 'fetch_success'
            state.transcripts = transcripts
        },

        fetch_userdata_request(state) {
            state.status = 'fetching_userdata'
        },

        fetch_userdata_success(state, payload) {
            state.status = 'fetching_userdata_success'
            state.user_id = payload.user_id
            state.username = payload.username
        },

        billing_fetch_request(state) {
            state.status = 'fetching_billing_data'
        },

        billing_fetch_success(state, billing_data) {
            state.status = 'fetch_billing_success'
            state.billing_data = billing_data
        },

        instructor_fetch_request(state) {
            state.status = 'fetching_data'
        },

        instructor_fetch_success(state, course_rosters) {
            state.status = 'fetch_success',
            state.course_rosters = course_rosters
            // state.nav_items = [
            //     {
            //         title: "Roster",
            //         icon: "mdi-account-multiple",
            //         route: "/roster"
            //     },
            //     {
            //         title: "Grades",
            //         icon: "mdi-lead-pencil",
            //         route: "/grades"
            //     }
            // ]
        },

        fetch_sections_request(state) {
            state.status = 'loading'
        },

        fetch_sections_success(state, sections) {
            state.status = 'fetch_sections_success'
            state.sections = sections
            window.console.log("MUTATION: "+ state.sections[0].title)
        },
        
        fetch_calendars_request(state) {
           state.status = 'loading'
        },

        fetch_calendars_success(state, calendars) {
            state.status = 'fetch_calendars_success',
            state.calendars = calendars
            for (var i = 0; i < state.calendars.length; i++) {
                var days_of_week = []
                if (state.calendars[i].monday === true) {
                    days_of_week.push("M")
                }
                if (state.calendars[i].tuesday === true) {
                    days_of_week.push("T")
                }
                if (state.calendars[i].wednesday === true) {
                    days_of_week.push("W")
                }
                if (state.calendars[i].thursday === true) {
                    days_of_week.push("TH")
                }
                if (state.calendars[i].friday === true) {
                    days_of_week.push("F")
                }
                state.sections[i].days_of_week = days_of_week.join(', ')
                state.sections[i].room = state.calendars[i].room
            }
            for (var k = 0; k < state.sections.length; k++) {
                window.console.log("DOW: "+state.sections[k].days_of_week)
            }
        },

        fetch_error(state) {
            state.status = 'error_fetching'
        },

        handle_expired_session(state) {
            state.status = 'session_expired'
            state.isLoggedIn = false
        },

        submit_grades(state) {
            state.grades_submitted = true
        },

        set_navigation(state, userType) {
            if (userType === 0) {
                state.nav_items = [
                    {
                        title: "Courses",
                        icon: "mdi-pencil",
                        route: "/courses"
                    },
                    {
                        title: "Registration",
                        icon: "mdi-playlist-check",
                        route: "/registration"
                    },
                    {
                        title: "Payment Receipt",
                        icon: "mdi-credit-card",
                        route: "/payment"
                    },
                    {
                        title: "Transcript",
                        icon: "mdi-clipboard-text",
                        route: "/transcript"
                    }
                ]
            }else if (userType === 1) {
                state.nav_items = [
                    {
                        title: "Rosters",
                        icon: "mdi-clipboard-text",
                        route: "/roster"
                    },
                    {
                        title: "Grades",
                        icon: "mdi-lead-pencil",
                        route: "/grades"
                    }
                ]
            }
        },

        set_instructors(state, instructor_names) {
            state.instructor_names = instructor_names
        }
    },
    actions: {
        setNavigation({commit}, userType) {
            commit('set_navigation', userType)
        },

        submitGrades({commit}, grades_submitted) {
            commit('submit_grades', grades_submitted)
        },
        
        login({commit}, access_token) {
            commit('auth_request')
            localStorage.setItem('token', access_token)
            // axios.defaults.headers.common['Authorization'] = token

            commit('auth_success', access_token)
            window.console.log(access_token)
        },

        fetch_instructor_data({commit}) {
            return new Promise((resolve, reject) => {
                commit('fetch_instructors_request')
                axios.get(process.env.VUE_APP_INSTRUCTOR_IDS_URL).then(resp => {
                   
                    resolve(resp.data)
                    commit('fetch_instructors_success', resp.data)
                }).catch(err => {
                    window.console.log(err)
                    reject(err)
                })
            })
        },

        fetch_user_data({commit}, access_token) {
            return new Promise((resolve, reject) => {
                commit('fetch_userdata_request')
                // TODO: Figure out how to get user info here to inform correct user type navigation / routing.
                axios.get(process.env.VUE_APP_API_ROOT + '/users/current/', { headers: {"Authorization" : `Bearer ${access_token}`} }).then(resp => {
                    window.console.log('USER DATA: ' + JSON.stringify(resp.data))
                    
                    var user_id = resp.data['adelphi_id']
                    var username = resp.data['username']
                    resolve(resp.data)
                    commit('fetch_userdata_success',{user_id: user_id, username: username})
                }).catch(err => {
                    window.console.log(err)
                    reject(err)
                })
            })
            
        },
        
        googleLogin({commit}, access_token) {
            commit('gauth_request')
            localStorage.setItem('token', access_token)
            commit('gauth_success', access_token)
        },

        logout({commit}) {
            commit('gauth_logout_request')
            localStorage.removeItem('token')
            window.location = 'https://portal.adelphi.edu/logout.php'
            // this.$gauth.signOut()
            commit('gauth_logout_success')
        },

        handleExpiredSession({commit}) {
            commit('gauth_logout_request')
            localStorage.removeItem('token')
            commit('gauth_logout_success')
        },

        googleLogout({commit}) {
            commit('gauth_logout_request')
            localStorage.removeItem('token')
            // this.$gauth.signOut()
            commit('gauth_logout_success')
        },

        // Not Used
        // fetchStudentTranscripts({commit}, auid) {
        //     return new Promise((resolve, reject) => {
        //         commit('fetch_request')
        //         window.console.log("Transcript Token: " + this.state.token)
        //         axios.get('https://neptune.adelphi.edu/~finkelstein/student-dashboard/remote-apis/student-api.php?auid=' + auid).then(resp => {
                
        //             var transcripts = resp['data']['transcripts'];
        //             commit('fetch_transcript_success', transcripts);
        //             resolve(resp)
        //         }).catch(err => {
        //             commit('fetch_error')
        //             reject(err)
        //         })
        //     })
        // },

        fetchStudentTerms({commit}) {
            return new Promise((resolve, reject) => {
                commit('fetch_request')
                window.console.log('TOK: '+this.state.token)
                axios.get(process.env.VUE_APP_API_ROOT + '/users/current/student_record/', { headers: {"Authorization" : `Bearer ${this.state.token}`} }).then(resp => {
                    var sectionIds = []
                    var credits = []
                    var grades = []
                    // const sections = resp.data.terms[0].sections
                    const terms = resp.data.terms
                    var sectionIdsString = "";
                    // if (!terms || terms.length === 0) {
                    //     commit('fetch_error')
                    //     reject(new Error('No terms found for this student'))
                    //     return
                    // }
                    for (var j = 0; j < terms.length; j++) {
                        var sections = terms[j].sections

                        for (var i = 0; i < sections.length; i++) {
                            window.console.log(sections[i].id)
                            sectionIds.push(sections[i].id)
                            credits.push(sections[i].credits_attempted)
                            grades.push(sections[i].grade)
                        }
                        window.console.log('Credits: ' + credits)
                        window.console.log('Grades: ' + grades)
                    }
                    sectionIdsString = sectionIds.join()
                    
                    commit('fetch_success', [sectionIdsString, credits, grades])
                    
                    resolve(resp)
                }).catch(err => {
                    commit('fetch_error')
                    window.console.error(err)
                    reject(err)
                })

            })

        },

        fetchStudentSections({commit}) {
            return new Promise((resolve, reject) => {
                commit('fetch_sections_request')
                axios.get(process.env.VUE_APP_API_ROOT + '/sections/?id='+this.state.sectionIdsString).then(resp => {
                    window.console.log("WHOOO" +resp.data)
                    const sections = resp.data.results
                    // TODO: Remove this. Need to get instructor IDs to map names.
                    window.console.log(JSON.stringify(sections))
                    commit('fetch_sections_success', sections)
                    resolve(sections)
                }).catch(err => {
                    commit('fetch_error')
                    reject(err)
                })
            })
        },

        fetchCourseCalendars({commit}) {
            return new Promise((resolve, reject) => {
                commit('fetch_calendars_request')
                axios.get(process.env.VUE_APP_API_ROOT + '/section_calendars/?section__id='+this.state.sectionIdsString)
                    .then(resp => {
                        commit('fetch_calendars_success', resp.data.results)
                        resolve(resp.data.results)  // TODO: Merge Calendar Data with Sections Data.
                    })
                    .catch(err => {
                        commit('fetch_error')
                        reject(err)
                    })
            })
        },

        fetchBillingData({commit}) {
            return new Promise((resolve, reject) => {
                commit('billing_fetch_request')
                axios.get(process.env.VUE_APP_API_ROOT + '/users/current/billing', { headers: {"Authorization" : `Bearer ${this.state.token}`} })
                    .then(resp => {
                        window.console.log('BILLING: ' + resp)
                        var new_billing_data = []
                        for (var i = 0; i < resp.data.length; i++) {
                            var term = resp.data[i].term
                            for (var j = 0; j < resp.data[i].items.length; j++) {
                                new_billing_data.push({'term': term, 'description': resp.data[i].items[j].description, 'date': resp.data[i].items[j].date, 'amount': resp.data[i].items[j].amount})
                            }
                        }

                        commit('billing_fetch_success', new_billing_data)
                        resolve(resp.data)
                    })
                    .catch(err => {
                        commit('fetch_error')
                        reject(err)
                    })
            })
        },

        fetchInstructorRoster({commit}) {
            return new Promise((resolve, reject) => {
                commit('instructor_fetch_request')
                axios.get(process.env.VUE_APP_API_ROOT + '/users/current/rosters/', { headers: {"Authorization" : `Bearer ${this.state.token}`}})
                    .then(resp => {
                        commit('instructor_fetch_success', resp.data)
                        window.console.log(resp.data)
                        resolve(resp.data)
                    })
                    .catch(err => {
                        commit('fetch_error')
                        window.console.error(err)
                        reject(err)
                    })
                // resolve('faculty roster here')
            })
        },

        fetchInstrutorsForId({commit}, instructorId) {
            return new Promise((resolve, reject) => {
                axios.get('https://class.adelphi.edu/cgi-bin/wwiz.asp?qtrieval&uname=donaldduck&uip=1.1.1.1&ws=ccapi')
                    .then(resp => {
                        window.console.log(instructorId + ' ' + JSON.stringify(resp.data))
                        commit(resp.data)
                        resolve(resp.data)
                    }).catch(err => {
                        commit('fetch_error')
                        reject(err)
                    })
            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        token: state => state.token,
        authStatus: state => state.status,
        userType: state => state.userType,
        user_id: state => state.user_id,
        username: state => state.username,
        terms: state => state.terms,
        sections: state => state.sections,
        transcripts: state => state.transcripts,
        credits: state => state.credits,
        grades: state => state.grades,
        calendars: state => state.calendars,
        course_rosters: state => state.course_rosters,
        instructor_names: state => state.instructor_names,
        billing_data: state => state.billing_data,
        nav_items: state => state.nav_items,
        all_instructor_ids: state => state.all_instructor_ids,
        instructor_ids: state => state.instructor_ids,
        former_students_now_instructors: state => state.former_students_now_instructors,
        grades_submitted: state => state.grades_submitted
    }
})